import { render, staticRenderFns } from "./Prestaciones.vue?vue&type=template&id=3523ee10&scoped=true"
import script from "./Prestaciones.vue?vue&type=script&lang=js"
export * from "./Prestaciones.vue?vue&type=script&lang=js"
import style0 from "./Prestaciones.vue?vue&type=style&index=0&id=3523ee10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523ee10",
  null
  
)

export default component.exports